/**
 * @generated SignedSource<<916730509a2c791ccf785e4193581425>>
 * @relayHash d91677b6bdf2827b223e02fa48634538
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 52347423fc309b58d7caef5263f97ca20e3066028d409931eaaa83ca3557c134

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { UserSegmentationRedirectEntryQuery } from './UserSegmentationRedirectEntryQuery.graphql';

const node: PreloadableConcreteRequest<UserSegmentationRedirectEntryQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "52347423fc309b58d7caef5263f97ca20e3066028d409931eaaa83ca3557c134",
    "metadata": {},
    "name": "UserSegmentationRedirectEntryQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
